import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./Auth/login/login";
import Signup from "./Auth/signup/signup";
import ForgotPassword from "./Auth/forgot-password/forgot-password";
import ResetPassword from "./Auth/reset-password/reset-password";
import Projects from "./Clients/projects";
import ProjectStepper from "./Project_stepper/Projectstepper";
import Profile from "./Auth/profile/profile";
import ClientLayout from "./Clients/Client_Layout";
import OrderTrackingPage from "./Clients/orderTracking";
import PaymentSuccessPage from "./Payments/PaymentSuccessPage";
import PaymentCancelPage from "./Payments/PaymentCancelPage";

import BackofficeLayout from "./Backoffice/backoffice";
import Dashboard from "./Backoffice/pages/dashboard";
import QuotesList from "./Backoffice/pages/quoteslist";
import QuoteDetail from "./Backoffice/pages/quotedetail";
import SupplierConfig from "./Backoffice/pages/supplierconfig";
import SurchargeRules from "./Backoffice/pages/surchargerule";
import ClientsPage from "./Backoffice/pages/clients";
import QuoteFollowup from "./Backoffice/pages/QuoteFollowup";
import QuotePurchases from "./Backoffice/pages/QuotePurchases";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:uidb64/:token" element={<ResetPassword />} />
        <Route path="/payments/success" element={<PaymentSuccessPage />} />
        <Route path="/payments/cancel" element={<PaymentCancelPage />} />

        <Route path="/app" element={<ClientLayout />}>
          <Route path="projects" element={<Projects />} />
          <Route path="projects/:projectId/steps" element={<ProjectStepper />} />
          <Route path="settings" element={<Profile />} />
          <Route path="quotes" element={<OrderTrackingPage />} />
          <Route path="order-tracking" element={<OrderTrackingPage />} />
        </Route>

        <Route path="/bo" element={<BackofficeLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="quotes" element={<QuotesList />} />
          <Route path="quotes/:quoteId/purchases" element={<QuotePurchases />} />
          <Route path="quotes/:quoteId/followup" element={<QuoteFollowup />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="quotes/:quoteId" element={<QuoteDetail />} />
          <Route path="config/suppliers" element={<SupplierConfig />} />
          <Route path="config/surcharges" element={<SurchargeRules />} />
        </Route>

        <Route path="*" element={<div style={{ padding: 24 }}>404</div>} />
      </Routes>
    </BrowserRouter>
  );
}

